import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MetaTags } from "react-meta-tags";
import Topnav from "../common/Topnav";
import Menubar from "../common/Menubar";
import Footer from "../common/footer"
import bannerImage from "../../Images/Banner/banner-5.png"
import sportsIntroImg from "../../Images/sports/sports1.jpeg";
import sport1 from "../../Images/sports/basketball.jpg";
import sport2 from "../../Images/sports/sports1.jpeg";
import sport3 from "../../Images/sports/WhatsApp Image 2025-07-11 at 11.38.19 AM.jpeg";
import sport4 from "../../Images/sports/full-shot-kid-running-with-ball.jpg";
import sport5 from "../../Images/sports/basketball.jpg";
import sport6 from "../../Images/sports/WhatsApp Image 2025-07-11 at 11.38.19 AM.jpeg";
import sport7 from "../../Images/sports/sports1.jpeg";

const Sports = () => {

    const sportsFacilities = [
        {
            iconClass: "ti ti-ball-football",
            title: "Football Ground",
            description: "A full-size, lush green football ground with stadium seating."
        },
        {
            iconClass: "ti ti-ball-basketball",
            title: "Basketball Court",
            description: "High-quality synthetic surface with night-light facility."
        },
        {
            iconClass: "ti ti-run",
            title: "Running Track",
            description: "400m international standard track for sprints and marathons."
        },
        {
            iconClass: "ti ti-trophy",
            title: "Awards & Trophies",
            description: "Our athletes shine at national and international platforms."
        },
    ];

    return (
        <React.Fragment>
            <MetaTags>
                {/* Meta tags content */}
            </MetaTags>
            <Topnav />
            <Menubar />
            <section className="sports-hero-banner" style={{
                backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
            }}>
                <div className="sports-hero-overlay">
                    <Container>
                        <div className="sports-hero-content">
                            <h1>Sports Excellence at ISBM University</h1>
                            <p>Where champions are made and dreams take flight</p>
                        </div>
                    </Container>
                </div>
            </section>

            {/* Sports Intro */}
            <section className="sports-intro-section">
                <Container>
                    <Row className="align-items-center">
                        <Col md={6}>
                            <div className="sports-intro-content">
                                <h2>Developing Champions On and Off the Field</h2>
                                <p>
                                    At ISBM University, we believe sports are an integral part of holistic education.
                                    Our state-of-the-art facilities and professional coaching staff provide students
                                    with opportunities to excel in their chosen sports while maintaining academic excellence.
                                </p>
                                <div className="sports-stats">
                                    <div className="sports-stat-item">
                                        <span className="stat-number">15+</span>
                                        <span className="stat-label">Sports Disciplines</span>
                                    </div>
                                    <div className="sports-stat-item">
                                        <span className="stat-number">25</span>
                                        <span className="stat-label">Professional Coaches</span>
                                    </div>
                                    <div className="sports-stat-item">
                                        <span className="stat-number">50+</span>
                                        <span className="stat-label">Tournaments Won</span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="sports-intro-image">
                                <img src={sportsIntroImg} alt="ISBM Sports Facilities" className="img-fluid rounded" />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>


            {/* Sports Facilities */}
            <section className="sports-facilities-section pb-100 sports-info-section">
                <Container>
                    <h2 className="section-title sports-info-title">World-Class Sports Facilities</h2>
                    <div className="sports-facilities-grid">
                        {sportsFacilities.map((facility, index) => (
                            <div key={index} className="sports-facility-card">
                                <div className="facility-icon">
                                    <i className={`${facility.iconClass} facility-icon-style`}></i>
                                </div>
                                <h3 className="facility-title">{facility.title}</h3>
                                <p className="facility-description">{facility.description}</p>
                            </div>
                        ))}
                    </div>
                </Container>
            </section>

            {/* Gallery Section */}
            <section className="sports-collage-gallery">
                <Container>
                    <h2 className="gallery-section-title">Sports Gallery</h2>
                    <p className="gallery-section-subtitle">Capturing the Spirit of Athletic Excellence</p>

                    <div className="collage-grid">
                        {/* Row 1 - 1 large image */}
                        <div className="collage-item large">
                            <div className="gallery-image-wrapper">
                                <img src={sport1} alt="Sports action shot" className="gallery-image" />
                                <div className="image-overlay">
                                    <div className="overlay-content">
                                        <h3>Football Championship</h3>
                                        <p>2023 Inter-University Tournament</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Row 1 - 2 small images */}
                        <div className="collage-item small">
                            <div className="gallery-image-wrapper">
                                <img src={sport2} alt="Basketball game" className="gallery-image" />
                                <div className="image-overlay">
                                    <div className="overlay-content">
                                        <p>Basketball Team Practice</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="collage-item small">
                            <div className="gallery-image-wrapper">
                                <img src={sport3} alt="Athletics competition" className="gallery-image" />
                                <div className="image-overlay">
                                    <div className="overlay-content">
                                        <p>Annual Athletics Meet</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Row 2 - 2 medium images */}
                        <div className="collage-item medium">
                            <div className="gallery-image-wrapper">
                                <img src={sport4} alt="Swimming competition" className="gallery-image" />
                                <div className="image-overlay">
                                    <div className="overlay-content">
                                        <h3>Swimming Pool</h3>
                                        <p>Olympic-size training facility</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="collage-item medium">
                            <div className="gallery-image-wrapper">
                                <img src={sport5} alt="Cricket match" className="gallery-image" />
                                <div className="image-overlay">
                                    <div className="overlay-content">
                                        <h3>Cricket Academy</h3>
                                        <p>Professional coaching sessions</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Row 3 - 3 small images */}
                        <div className="collage-item small">
                            <div className="gallery-image-wrapper">
                                <img src={sport6} alt="Tennis match" className="gallery-image" />
                                <div className="image-overlay">
                                    <div className="overlay-content">
                                        <p>Tennis Tournament</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="collage-item small">
                            <div className="gallery-image-wrapper">
                                <img src={sport7} alt="Yoga session" className="gallery-image" />
                                <div className="image-overlay">
                                    <div className="overlay-content">
                                        <p>Yoga & Wellness</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>

            {/* Call to Action */}
            <section className="sports-cta-section sports-join-section">
                <Container>
                    <div className="sports-cta-card">
                        <div className="sports-cta-content">
                            <h2>Ready to Join Our Winning Team?</h2>
                            <p>
                                Whether you're an aspiring athlete or just want to stay active,
                                ISBM University has the perfect sports program for you.
                            </p>
                            <div className="cta-buttons">
                                <Link to="/sports-registration" className="sports-cta-button primary">
                                    Register for Trials
                                </Link>
                                <Link to="/sports-facilities" className="sports-cta-button secondary">
                                    Tour Our Facilities
                                </Link>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>

            <Footer />
        </React.Fragment>
    );
};

export default Sports;
